<template>
    <div v-if="type === 'cancel'" @click="cancel" class="cancel-button">
        <font-awesome-icon class="mr-2" :icon="['fas', 'xmark']" />
        <span class="text-underline">{{ label ? ($te(label) ? $t(label) : label) : $t('sign_feedback.cancel') }}</span>
    </div>
    <button
        v-else-if="type === 'button'"
        :disabled="disabled || loading"
        :class="{
            'vgtc-button--disabled': disabled,
            ' box-shadow-none': !disabled,
            'vgtc-button': !disabled && variant === 'primary',
            'vgtc-button--secondary': !disabled && variant === 'secondary',
            'vgtc-button--icon': isIconButton,
        }"
        @click="click"
    >
        <b-spinner small v-if="loading" class="mr-2"></b-spinner>
        <font-awesome-icon v-else-if="icon" class="icon" :class="{ 'mr-2': !isIconButton }" :icon="icon" />
        <span :class="{ 'sr-only': isIconButton }">{{ $te(label) ? $t(label) : label }}</span>
    </button>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({ components: {} })
export default class Button extends Vue {
    @Prop({ default: 'button' }) public type!: 'cancel' | 'button';
    @Prop({ default: false }) public disabled!: boolean;
    @Prop({ default: false }) public loading!: boolean;
    @Prop({ default: false }) public isIconButton!: boolean;
    @Prop({ default: 'primary' }) public variant: 'primary' | 'secondary';
    @Prop() public label?: string;
    @Prop() public icon?: string[];

    @Emit('click')
    public click() {
        return;
    }

    @Emit('cancel')
    public cancel() {
        return;
    }
}
</script>

<style lang="scss" scoped>
.vgtc-button--disabled {
    align-items: center;
    display: flex;
    padding: 0.5rem 1rem 0.5rem 1rem;
    border-radius: $default-border-radius;
    color: $disabled-text-color;
    background-color: $disabled-color;
    border: $thin-border-size solid $disabled-color;
}

.cancel-button {
    cursor: pointer;
}

.vgtc-button--secondary {
    align-items: center;
    display: flex;
    padding: 0.5rem 1rem 0.5rem 1rem;
    border-radius: $default-border-radius;
    color: $accent-color;
    background-color: transparent;
    border: none;

    &:hover {
        color: $accent-text-color-hover;
        background-color: $accent-color;
    }
}

.icon {
    font-size: 1em;
}

.vgtc-button--icon {
    padding: 1rem;
}
</style>
